import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Alert } from 'src/app/interfaces/alert';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  alert: Alert = null;
  isBrowser: boolean;
  public renderRebrandedContent: boolean = false;

  constructor(
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.renderRebrandedContent = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  displayAlert(alertText: string) {
    this.alert = {
      type: 'danger',
      message: alertText,
    };
  }

  closeAlert() {
    this.alert = null;
  }
}
